var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-country-picker"},[_c('i-dropdown',{attrs:{"name":_vm.name,"label":_vm.label,"value":_vm.value,"options":_vm.options},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }